<template>
    <ui-modal ref="modal" title="Lost Lead" dismiss-on="close-button esc">
        <ui-select
            :label="'Why did we lose ' + lead.contact.primary_display_as + '\'s business?'"
            placeholder="Select reason"
            v-model="outcome_reason"
            :options="outcomeReasons"
            :disabled="isBusy"
        ></ui-select>
        <ui-textbox
            v-model="outcome_notes"
            multi-line
            :rows="3"
            :disabled="isBusy"
            placeholder="Additional notes"
        ></ui-textbox>
        <ui-button @click="save" color="primary" :disabled="isBusy">Save</ui-button>
    </ui-modal>
</template>

<script>
import {LeadResource} from "../../classes/Api/Lead";
import DealerKit from "../../api";

export default {
    props: {
        lead: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            outcomeReasons: [],
            outcome_notes: '',
            outcome_reason: '',
            isBusy: false
        }
    },
    methods: {
        open() {
            this.outcome_notes = ''

            this.isBusy = true

            DealerKit.leads.getlostLeadOutcomes().then(r => {
                this.outcomeReasons = r.data.data.map(r => {
                    return {
                        label: r.label,
                        value: r.label
                    }
                })

                this.isBusy = false
            }).catch(() => {
                this.isBusy = false
            })

            this.$refs.modal.open()
        },
        close() {
            this.$refs.modal.close()
        },
        save() {
            this.isBusy = true;
            LeadResource.lost(this.lead.id, { outcome_notes: this.outcome_notes, outcome_reason: this.outcome_reason.label }).then(r => {
                this.close()

                this.$emit('lost')
            }).catch(handleApiError).finally(() => { this.isBusy = false })
        }
    }
}
</script>

<style scoped>

</style>